import { ConfigProvider } from "melco-ui";
import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useXMLOrdersPathDropdown } from "../../hooks/inputFormats/useXMLOrdersPathDropdown";

export const XMLInputFormatDetailForm: React.FC = () => {
  const { t } = useTranslation();

  const options = useXMLOrdersPathDropdown();

  return (
    <ConfigProvider renderEmpty={() => <>{t("global.fallback.none")}</>}>
      <SelectField
        name="xml_orders_xpath"
        label={t("inputFormats.detail.form.label.xml_orders_xpath")}
        style={{ width: "100%" }}
        options={options}
        showSearch
        optionFilterProp="label"
        filterOption
        allowClear
        placeholder={t("global.fallback.none")}
      />
    </ConfigProvider>
  );
};
